import ComponentHelper from '../../../supers/ComponentHelper';
import React from 'react';
import GraphiQL from 'graphiql';
import './gql-panel.css';
import 'graphiql/graphiql.css';
import RESTService from '../../../services/RESTService';
const connect = new RESTService();

class GQLPanel extends ComponentHelper {
	constructor(props) {
		super(props);
		this.autoBindAll(this);
	}

	graphQLFetcher(graphQLParams) {
		return connect.graphQuery({ query: graphQLParams.query }).then(response => response.data);
	}

	onEditQuery(query) {
		if (this.props.onChange) {
			this.props.onChange(query);
		}
	}

	render() {
		return (
			<div className={`gql-panel`}>
				<GraphiQL fetcher={this.graphQLFetcher} query={''} onEditQuery={this.onEditQuery} />
			</div>
		);
	}
}

export default GQLPanel;



// WEBPACK FOOTER //
// ./src/views/entities-panel/GQLPanel/GQLPanel.js